import TimeFix from './time'

export default TimeFix
